var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('tab',{key:'project-modal-tab' + index,attrs:{"icon":tab.icon,"txt":tab.title,"active":_vm.tabIndex === index,"index":index,"onClick":_vm.onClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }